import React, { useEffect } from 'react'
import { useStateValue } from '@State'
import { client } from '@Utils'
import { codeOrderManagement as endpoints } from '@URLS'
import { DetailInfo } from './DetailInfo'
import { CodeContainer } from './CodeContainer'
import { toast } from '@CommonComponents/toast'

export const Details = ({ orderId }) => {
  let [currentState, dispatch] = useStateValue()

  const handleSend = async () => {
    try {
      const response = await client.post(`/account/admin_coupons.send_to_customer/-/?order_id=${orderId}`)
      if (response.status === 200) {
        toast.success('Successfully sent codes to recipient.')
      }
    } catch (error) {
      if (error.response && error.response.data && error.response.data.error) {
        toast.error(`There was an error sending codes. ${error.response.data.error}`)
      }
    }
  }

  useEffect(() => {
    const fetchCodes = async () => {
      let resp = await client.get(endpoints.fetchCodes({ orderId: orderId }))
      dispatch({
        type: 'updateOrderCodes',
        payload: {
          order: resp.data.order,
          codes: resp.data.codes,
        },
      })
    }
    fetchCodes(orderId)
  }, [])
  let order = currentState.order
  let codes = currentState.codes
  return (
    <React.Fragment>
      <button 
        className="btn btn-myed btn-link-myed"
        onClick={() => history.go(-1)}
      >
        <i className="fa-regular fa-long-arrow-left mr-2" />Go back
      </button>
      <div className="d-flex justify-content-between align-items-end mb-4">
        <div>
          <h2>Order Details</h2>
          <div className="text-muted">Order #{order ? order.id : ''}</div>
        </div>
        <div className="d-flex flex-column align-items-end">
          <button
            className="btn btn-myed btn-default btn-default-myed btn-sm-myed mb-2"
            onClick={handleSend}
          >
            <span className="fa-regular fa-paper-plane fa-fw mr-2"></span>Send
          </button>
          {order.sentOn && (
            <div className="text-success">
              Codes last sent on {new Date(order.sentOn).toLocaleString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
              })} UTC
            </div>
          )}
          <div className="text-muted">Codes will be emailed to {order.contactEmail}</div>
        </div>
      </div>
      <div className="card-myed d-flex">
        {order && (
          <DetailInfo
            created={order.created}
            coursenum={order.coursenum}
            orderedCourseTitle={order.courseTitle}
            numCodes={order.numCodes}
            contactName={order.contactName}
            contactEmail={order.contactEmail}
            institution={order.institution}
            courseIdentifier={order.courseIdentifier}
            comments={order.comments}
            poNumber={order.poNumber}
            price={order.price}
            pmtMethod={order.pmtMethod}
            pmtDate={order.pmtDate}
            txnId={order.txnId}
            invoiceNum={order.invoiceNum}
            invoiceStatus={order.invoiceStatus}
            internalNotes={order.internalNotes}
            orderId={orderId}
          />
        )}
      </div>
      <h2 className="mb-0">Codes</h2>
      {codes &&
        codes.map((code, i) => (
          <CodeContainer
            key={i}
            id={code.id}
            code={code.builtCode}
            created={code.created}
            expiration={code.expiration}
            assigned={code.assigned}
            assignedTo={code.assignedTo}
            assignedCourse={code.assignedCourse}
            redeemedOn={code.redeemedOn}
            redeemedBy={code.redeemedBy}
            redeemedCourse={code.redeemedCourse}
            status={code.status}
            notes={code.notes}
            orderId={orderId}
          />
        ))}
    </React.Fragment>
  )
}
